import type { BankAccountMetaData } from "../stores/BankAccountStore";

export enum PlaidCustomization {
  Default = "default",
  MultiSelect = "provipay",
}

export interface PlaidModalParams {
  customization?: PlaidCustomization;
  isMicrodeposit?: boolean;
  afterSuccess?: (metadata: BankAccountMetaData) => void;
  afterExit?: () => void;
  onLoad?: () => void;
  afterMicrodepositFailure?: () => void;
  plaidAccountIds?: number[];
}
